import React, { FC, useState } from 'react'
import { Button, message } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import {
  postMaterialTemplate,
  uploadImage as uploadImg,
  updateMaterialTemplate,
} from '@/services/creativeMaterialService'
import { MaterialRouteProps } from '@/pages/material'
import { LoadingOutlined } from '@ant-design/icons'
import utils from '@/utils/utils'
import { getUserName } from '@/utils/session'
interface HeaderProps {
  instance: any
}

const uploadImage = (blob: Blob, name = utils.generateImgName()): void => {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a') as HTMLAnchorElement
  a.download = name
  const event = new MouseEvent('click')
  a.href = url
  a.dispatchEvent(event)
  URL.revokeObjectURL(url)
}

const Header: FC<HeaderProps> = ({ instance }) => {
  const history = useHistory()
  const params = useParams<MaterialRouteProps>()
  const isEditor = params.type === 'editor'
  const [loading, setLoading] = useState(false)
  const handerSaveImage = () => {
    instance?.toCanvasElement(2).toBlob((res: Blob) => {
      uploadImage(res)
    })
  }
  const handleSaveTemplate = () => {
    setLoading(true)
    instance?.toCanvasElement(2).toBlob((img: Blob) => {
      uploadImg(img, {
        format: 'png',
        fulldim: '300x300',
        path: `${utils.generateImgName()}.png`,
      })
        .then(res => {
          isEditor
            ? updateMaterialTemplate(params.id, {
                id: params.id,
                content: instance?.toJSON(),
                meta: {
                  height: instance.height,
                  width: instance.width,
                },
                link: `https://baleen-cdn-g.bybieyang.com/${res.data.name}`,
                author: getUserName(),
              })
                .then(() => {
                  message.success('修改成功')
                })
                .finally(() => {
                  setLoading(false)
                })
            : postMaterialTemplate({
                content: instance?.toJSON(),
                link: `https://baleen-cdn-g.bybieyang.com/${res.data.name}`,
                meta: {
                  height: instance.height,
                  width: instance.width,
                },
                author: getUserName(),
              })
                .then(() => {
                  message.success('保存成功')
                })
                .finally(() => {
                  setLoading(false)
                })
        })
        .catch(() => {
          setLoading(false)
        })
    })
  }
  const handleNavigation = () => {
    history.push('/material/list')
  }
  return (
    <div className="material-header">
      <Button size="small" onClick={handerSaveImage}>
        保存图片
      </Button>
      <Button
        size="small"
        onClick={handleSaveTemplate}
        icon={loading ? <LoadingOutlined /> : null}
        disabled={loading}
      >
        {isEditor ? '确认修改' : '保存模板'}
      </Button>
      <Button size="small" onClick={handleNavigation}>
        导入模板
      </Button>
    </div>
  )
}

export default Header
